<template>
  <div class="containerNcm">
      <div class="painel">
          <img src="https://www.lefisc.com.br/sandboxfront/tv/img/TVLefisc.svg" alt=""  width="190"> 
          <p>Vídeos explicativos dos<br>principais assuntos<br>do momento</p>
      </div>
      <div class="inputCaixa">
        <form v-on:submit.prevent="pesquisar()" style="display:flex;">
          <input type="text"   v-model="texto" required=""> <button type="submit" style="margin-left:0px;"><i class='fas fa-search'></i> Pesquisar</button>
          <label for="texto">buscar por palavra</label>
        </form>
        <p style="color:red;margin:10px 0px;">{{msg}}</p>
      </div>
      <main>
        <p class="titulo">Lista de Vídeos</p>
        <div class="controle">
          <div class="caixa" @click="mostraMeunLateral()">
              <p class="p1">{{p1}}</p>
              <p style="margin-top: 3px;">{{p}}</p>
          </div>
          <div  class="ajusteCaixa">
            <div class="caixa2" @click="exibirCa()">
              <p>Classificar por </p>  
              <span :class="{seta:true,setaA:setaA}"> </span> 
            </div>
            <div :class="{exibirCaixa:true,exibirCaixaA:exibirCaixaA}">
                <p class="txtAcesa" @click="getTodas2()">Mais recentes</p>
                <p class="txtAcesa" @click="todasMaisAcessadas()">Mais acessados</p>
            </div>
          </div>
        </div>
        <div :class="{conteudoP:true, conteudoPActive:conteudoPActive}">
          <div class="menuLateral">
            <div style="margin-bottom:30px;">
              <div class="redefinir"> <div> </div> Refinar por </div> <p v-show="limpar" @click="limparT()">limpar</p>
            </div>
            <div class="categorias">
              <p class="txtCategoria">Categorias</p>
              <div class="inputCheck" v-for="c in categorias" :key="c.$id">
                <input type="radio" name="p" :id="c.$id.concat('categoria')">
                <label :for="c.$id.concat('categoria')"  @click="porCategoriaUltimas(c.idCategoria)">{{c.nome}}</label>
              </div>
              <hr>
              <p class="txtCategoria">Estados</p>
               <div class="inputCheck" v-for="e in estados" :key="e.$id">
                <input type="radio" name="p" :id="e.$id.concat('estado')">
                <label :for="e.$id.concat('estado')" @click="porCategoriaUltimas(e.idCategoria)">{{e.nome}}</label>
              </div>
            </div>
          </div>
          <div class="videos">                        
              <div v-show="spiner" v-for="a in lists" :key="a.$id"  :class="{cardVideo:cardVideo,cardVideoA:cardVideoA}" @click="irParaVideo(a.idTV,a.idCategoria)">
                  <img :src="a.miniatura" alt="" width="100%" > 
                  <p style="color: #808080;margin-top:5px;">{{a.data}}</p>
                  <p style="color: #808080;font-weight:bold;">{{a.titulo.substring(0,65)}}</p>
              </div>
              <div v-if="videos.length == 0 && spiner && nenhum" style="display: flex;
  justify-content:center;padding-top:150px; width:100%;">
                  <p style="font-size:22px"> Nenhum video encontrado </p> 
              </div>
            <div v-show="!spiner" style="height:109vh;width:100%">
              <div class="d-flex justify-content-center mb-3" style="padding-top:100px;">
                <b-spinner style="width: 5rem; height: 5rem;" label="Large Spinner"></b-spinner>
              </div>
            </div>              
          </div>
        </div>
          <div class="paginacao" v-if="videos.length != 0">
                    <b-pagination
                        v-model="currentPage"
                        size="sm" 
                        :per-page="perPage"
                        :total-rows="videos.length"
                        first-text="<"
                        prev-text="<<"
                        next-text=">"
                        last-text=">>">
                    </b-pagination>
                </div>
       
      </main>
  </div>
</template>

<script>
import config from '../services/config.js'
export default {
    data(){
        return{
           texto:'',
           p:'Ocultar filtros',
           p1:'x',
           categorias:[],
           estados:[],
           videos:[],
           conteudoPActive:false,
           limpar:false,
           spiner:true,
           temConteudo:false,
           cardVideoA:false,
           cardVideo:true,
           rows:10,
           perPage: 9,
           currentPage: 1,
           exibirCaixaA:false,
           setaA:false,
           msg:'',
           textoTmp:'',
           nenhum:false
           
        }
    },
    methods:{  
      irParaVideo(idTv,categoria){
          this.$router.push({
            name:'video',
            params:{idTv,categoria}
          })
      },  
      async pesquisar(){       
        if(this.texto.length >=2){         
          this.spiner = !this.spiner        
          let array = []
           let p = document.getElementsByName('p')
          let check = false
          let catego = 1
          for(let i =0; i <p.length;i++){
            if(p[i].checked == true){
              check = true;
              catego = i+1
              break;
            }
          }      
          if(catego == 10  || catego == 11 || catego == 12){
            catego = catego + 2
          }
          if(check && this.texto.length >=2){            
             array = await config.porCategoriaUltimasPorPalavra(catego,this.texto.trim())                  
              if(array.length>= 1){
                this.videos = array
                this.ajusteData(this.videos)   
                this.spiner = !this.spiner                
                this.msg = ''
              }else{
                this.texto = ''
                this.spiner = !this.spiner 
                this.msg = 'Nenhum vídeo encontrada'
              }
            console.log('categoria e palavra')
          }else if(this.texto.length >=2){
            console.log('palavra')
              array = await config.porPalavra(this.texto.trim())                  
              if(array.length>= 1){
                this.videos = array
                this.ajusteData(this.videos)   
                this.spiner = !this.spiner                 
                this.msg = ''
              }else{
                this.texto = ''
                this.spiner = !this.spiner 
                this.msg = 'Nenhuma vídeo encontrada'
              }
          }
        }
      },
      exibirCa(){
        this.exibirCaixaA = !this.exibirCaixaA
        this.setaA = !this.setaA
      },
      mostraMeunLateral(){        
        this.cardVideoA = !this.cardVideoA
        if(this.p1 == 'x'){
          this.p = 'Mostrar filtros'
          this.p1 = '+'
          this.conteudoPActive = true             
        }else{  
          this.p = 'Ocultar filtros'
          this.p1 = 'x'
          this.conteudoPActive = false
        }
      },
      async getTodas(){
        this.spiner = false;
        this.videos = await config.getTodas()     
        this.ajusteData(this.videos)   
        this.spiner = true;
        this.nenhum = true
      },
      limparT(){
        let p = document.getElementsByName('p')          
        for(let i =0; i <p.length;i++){
          p[i].checked = false
        }      
        this.limpar =false
      },
       async getTodas2(){
        this.msg =''
        this.exibirCa()
        this.spiner = !this.spiner
         let p = document.getElementsByName('p')
        let check = false
        let catego = 1
        for(let i =0; i <p.length;i++){
          if(p[i].checked == true){
            check = true;
            catego = i+1
            break;
          }
        }      
          if(catego == 10  || catego == 11 || catego == 12){
            catego = catego + 2
          }
        if(check && this.texto.length >=2){
          this.videos = await config.porCategoriaUltimasPorPalavra(catego,this.texto.trim())
          console.log('categoria e palavra')
        } 
        else if(check){
          this.videos = await config.porCategoriaUltimas(catego)
          console.log('categoria')
        }
        else if(this.texto.length>=2){
          this.videos = await config.ultimasPorPalavra(this.texto.trim())
          console.log('palavra')
        }else{
          this.videos = await config.getTodas()
          console.log('todos')
        }
        this.ajusteData(this.videos)
        this.spiner = !this.spiner
      },
      async getCategEstado(){        
        const array = await config.getCategEstado()        
        const arrayFiltrado = array.reduce((valorAcumulador,valorArray)=>{
            const result = valorArray.idCategoria <= 4  || valorArray.idCategoria == 13? 'categorias' : 'estados'
            valorAcumulador[result].push(valorArray)
            return valorAcumulador
        },{categorias:[],estados:[]})        
        this.categorias = arrayFiltrado.categorias
        this.estados = arrayFiltrado.estados       
      },
      async porCategoriaUltimas(categoria){       
        this.spiner = !this.spiner
        this.limpar = true
        if(this.texto.length>=2){
          this.videos =   await config.porCategoriaUltimasPorPalavra(categoria,this.texto.trim())   
        }else{
          this.videos = await config.porCategoriaUltimas(categoria)
        }
        this.ajusteData(this.videos)
        this.spiner = !this.spiner
      },
      async todasMaisAcessadas(){
        this.msg =''
        this.exibirCa()
        this.spiner = !this.spiner
        let p = document.getElementsByName('p')
        let check = false
        let catego = 1
        for(let i =0; i <p.length;i++){
          if(p[i].checked == true){
            check = true;
            catego = i+1
            break;
          }
        }
          if(catego == 10  || catego == 11 || catego == 12){
            catego = catego + 2
          }
        console.log(p)
        if(check && this.texto.length >=2){
          this.videos = await config.porCategoriaMaisAcessadasPorPalavra(catego,this.texto.trim())
          console.log('categoria e palavra')
        } 
        else if(check){
          this.videos = await config.porCategoriaMaisAcessadas(catego)
          console.log('categoria')
        }
        else if(this.texto.length>=2){
          this.videos = await config.todasMaisAcessadaPorPalavra(this.texto.trim())
          console.log('palavra')
        }else{
          this.videos = await config.todasMaisAcessadas()
          console.log('todas')
        }
        this.ajusteData(this.videos)
        this.spiner = !this.spiner
      },
      ajusteData(elemento){
          elemento.forEach(element => {
              element.data = element.data.substring(8,10) + '/'+element.data.substring(5,7) +'/'+element.data.substring(0,4)
          });
      }
    },
    computed:{
      lists(){            
         return this.videos.slice(
            (this.currentPage - 1)  * this.perPage, this.currentPage * this.perPage)
      }
    },
    mounted(){
       window.scrollTo(0,0)
        this.getCategEstado()
        this.getTodas()
    },
    
}
</script>

<style>
.seta{
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid black;
  transform: rotate(0deg);
  transition: 0.5s all;
}
span.setaA{
  transition: 0.5s all;
  transform: rotate(180deg);
}
.txtAcesa{
  color: #808080;font-style:italic;margin-left:25px;font-size:18px;cursor: pointer;
}
.ajusteCaixa{
  position: relative;
}
.ajusteCaixa .exibirCaixa{
  width: 212px;
  height: 0;
  opacity: 0;
  top:40px;
  position:absolute;
  transition: 0.4s all;
  border: 1px solid #707070;
  background: #fff;
  padding-top:10px;
}
.ajusteCaixa div.exibirCaixaA{
  height: 100px;
  opacity: 1;
  transition: 0.4s all;
}
.containerNcm{
    margin:0 auto;
    max-width: 1160px; 
    background: #fff;
}
.painel{
    background-image: url('https://www.lefisc.com.br/sandboxfront/tv/img/lanterna.jpg');
    background-color: #D6652B;
    background-blend-mode: multiply;
    height: 60vh;
    width: 100%;    
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-position: center;
}
.painel p{
  color:#fefefe;
  text-align:right;
  margin-right:80px;
  font-style: italic;
  font-weight: bold;
  font-size: 42px;
}
.painel img{
  margin-left: 80px;
}
.inputCaixa{
    max-width: 521px;
    position: relative;
    margin:80px auto;
    height: 38px;
}
.inputCaixa label{
    position: absolute;
    bottom:-1px;
    opacity: 0.5;
    left:12px;
    font-size: 18px;
    color: #555;
    pointer-events: none;
    transition: 0.3s all;
}
.inputCaixa input{
    height: 38px;
    width: 400px;
    outline: none;
    position: relative;
    z-index: 2;
    padding-left:20px;
    border: 1px solid #707070;
    background:none;   
}
.inputCaixa input:focus ~ label,
.inputCaixa input:valid ~ label{
    bottom:18px;
    background: #fff;
    opacity: 1;
    z-index: 3;
}
.inputCaixa  button{ 
    height: 38px;
    margin-left:-5px;
    position: relative;
    border-radius: 0px 5px 5px 0px;
    background: #D6652B ;
    color:#fff;
    border:1px solid #D6652B ;
    width: 120px;
    text-transform: lowercase;
    font-size:16px;
    padding-left:23px;
    outline: none;
    cursor: pointer;
}
.inputCaixa  button:hover{
  background: rgb(194, 76, 16);
  border:1px solid rgb(204, 82, 22);
}
.inputCaixa button .fa-search{
  margin-left: -8px;
  position: absolute;
  left:20px;
  top:10px;
}
.inputCaixa button:hover .fa-search{
  font-size:19px;
}
main{
  max-width: 1050px;
  margin:0 auto;
}
main .titulo{
  color: #808080;
  font-style: italic;
  font-size: 26px;
  font-weight: bold;
  border-bottom:  1px solid #808080;
  padding-bottom: 5px;
}
main .controle{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top:30px;
  margin-bottom: 50px;
}
main .controle .caixa{
  width: 180px;
  height: 45px;
  background: #D6652B;
  border-radius: 5px;
  padding:0px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color:#fff;
  cursor: pointer;
}
main .controle .caixa p{
  font-size: 18px;
  font-weight: bold;
  font-style: italic;
  margin-bottom: 0;
}
main .controle .caixa .p1{
  font-size: 22px;
  margin-bottom: 0;
  font-weight: 500;
  font-style: normal;
}
main .controle .caixa2{
  position: relative;
  width: 212px;
  height: 45px;
  border-radius: 5px; 
  padding:0px 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #808080;
  cursor: pointer;
  border:1px solid #707070;
}
main .controle .caixa2 p{
  font-style: italic;
  font-weight: bold;
  font-size:18px;
  margin-bottom: 0;
}
main .conteudoP{
  display: flex;  
  margin-bottom: 30px;
}
main .conteudoP .menuLateral{
  width: 190px;
  transition:width 0.6s, 0.6s all ;
  margin-top:30px;
  opacity: 1;
}
main .conteudoPActive .menuLateral{
  width: 0px;
  opacity: 0;
  transition:width 0.6s, 0.6s all ;
}
main .menuLateral div:nth-child(1){
  display: flex;
  justify-content: space-between;
}
main .menuLateral div:nth-child(1) .redefinir{
    color:#808080;
    font-style: italic;
    font-weight: bold;
    font-size: 17px;
}
main .menuLateral div:nth-child(1) .redefinir div{
  width: 30px;
  height: 4px;
  background: #808080;
  position: relative;
  margin-right:5px;
  display: flex;
  justify-content: center;
  border-radius: 5px;
}
main .menuLateral div:nth-child(1) .redefinir div::before{
  content: '';
  position: absolute;
  width: 20px;
  height: 4px;
  background: #808080;
  top:10px;
  border-radius: 5px;
}
main .menuLateral div:nth-child(1) .redefinir div::after{
  content: '';
  position: absolute;
  width: 10px;
  height: 3px;
  background: #808080;
  top:20px;
  border-radius: 5px;
}
main .menuLateral div:nth-child(1) p{
  color: #D6652B;
  font-style: italic;
  margin-top:4px;
  cursor: pointer;
  margin-bottom: -4px;
}
main .menuLateral .categorias .inputCheck{
  position: relative;
  height: 40px;
}
main .menuLateral .categorias .inputCheck input{
  display: none;
}
main .menuLateral .categorias .inputCheck input:checked + label::after{
    content: "";
    position: absolute;
    bottom: 4px;
    left: 7px;
    width: 8px;
    height: 15px;
    border-right: 4px solid #D6652B;
    border-bottom: 4px solid #D6652B;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
}

main .menuLateral .categorias .inputCheck label{
  position: relative;
  font-size: 13px;
 padding-left: 28px;
}
main .menuLateral .categorias .inputCheck label::before{
  content: "";
  width: 20px;
  height: 20px;
  position: absolute;
  border: 1px solid #707070;
  border-radius: 5px;
  display: inline-block;
  box-sizing: border-box;
  left:0px;
  
}
main .menuLateral .categorias .txtCategoria{
  font-style: italic;
  font-weight: bold;
  font-size:18px;
  color: #808080;
}
main .conteudoP .videos{   
  width: 860px;
  transition:width 0.6s ;
  display: flex;
  flex-wrap: wrap;
}
main .conteudoPActive .videos{
  width: 1050px;
  margin-left:0px;
}
main .conteudoP .videos div.cardVideoA{
  width: 336px;
  height: 299px;
  transition: height  0.6s, width 0.6s, 0.6s all;
  margin-left:0px;
}
main .conteudoP .videos div.cardVideoA p{
    font-size:18px;
    transition:  0.6s all;
}
main .conteudoP .videos  div.cardVideoA img{
  height: 180px;
  transition:  0.6s all;  
}
main .conteudoP .videos  div.cardVideoA:nth-child(2){
  margin-left:20px;
  margin-right:20px;
}
main .conteudoP .videos div.cardVideoA:nth-child(5){
  margin-left:20px;
  margin-right:20px;
}
main .conteudoP .videos  div.cardVideoA:nth-child(8){
  margin-left:20px;
  margin-right:20px;
}
main .conteudoP .videos .cardVideo{
  cursor: pointer;
  width: 269px;
  height: 245px;
  border-radius: 10px;
  border:1px solid #707070;
  margin-left:17px;
  margin-top:30px;
  transition: height  0.6s, width 0.6s, 0.6s all;
}
main .conteudoP .videos .cardVideo img{
  height: 150px;
  width: 100%;
  transition:  0.6s all;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
  
}
main .conteudoP .videos .cardVideo p{
  font-size:14px;
  margin-bottom: 0px;
  margin-left:9px;
  margin-right:9px;
  transition:  0.6s all;
}
.paginacao{
    display: flex;
    justify-content: flex-end;
    margin:20px 0px;
}
.pagination-sm .page-item:first-child .page-link{
    padding:8px;
    padding-left:9px;
    padding-right:9px;
    border-radius: 5px;
    background: #EEEEEE;
    color: #616161;     
    border: #fff;
}


.page-link:not(:disabled):not(.disabled) {
    cursor: pointer;
    padding: 8px;
    padding-left:9px;
    padding-right:9px;
    border-radius: 5px;
    background: #EEEEEE;
    color: #616161;
    border: #fff;
}
.page-link:not(:disabled):not(.disabled):hover {
    cursor: pointer;
    padding: 8px;
    padding-left:9px;
    padding-right:9px;
    border-radius: 5px;
    background: #D6652B ;
    color: #EEE;
    border: #EEE;
}
.page-item.disabled .page-link{
    padding:8px;
    padding-left:9px;
    padding-right:9px;
    border-radius: 5px;    
}
.pagination .page-item{
    border-radius: 10px;
    padding:5px;     
}
.active .page-link:not(:disabled):not(.disabled){
    background: #D6652B ;
    color:#fff;
    border: rgb(255, 255, 255);
}
button.page-link:focus{
  outline: none;
}
</style>